import request from '@/providers/http-service'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`
// const url = `${process.env.VUE_APP_API_DOMAIN}`



/**
 * 查询单条数据
 */
export function fullDetail(params) {
  return request({
    url: url + '/shanghu-task/fullDetail',
    method: 'get',
    params
  })
}

/**
 * 商户打卡列表
 */
export function byShanghuAnisPage(params) {
  return request({
    url: url + '/shanghu-task/byShanghuAnisPage',
    method: 'post',
    data: params
  })
}

/**
 * 商户打卡列表
 */
export function byShanghuAnisPage2(params) {
  return request({
    url: url + '/shanghu-task/bySubEventAnisPage',
    method: 'post',
    data: params
  })
}

// 堆物堆料打卡列表
export function recordPage(params) {
  return request({
    url: url + '/stackingMaterials/recordPage',
    method: 'post',
    data: params
  })
}

// 堆物堆料打卡信息
export function reportRecordDetail(params) {
  return request({
    url: url + '/stackingMaterials/reportRecordDetail',
    method: 'post',
    data: params
  })
}

// 堆物堆料打卡详情
export function reportRecordfullDetail(params) {
  return request({
    url: url + '/stackingMaterials/fullDetail',
    method: 'post',
    data: params
  })
}

export function reportRecordAuditBatch(params) {
  return request({
    url: url + '/stackingMaterials/approval',
    method: 'post',
    data:params
  })
}


// 事项标准管理分页查询
export function indexPage(params) {
  return request({
    url: url + '/gh-event-index/page',
    method: 'post',
    data: params
  })
}

/**
 * 商户填报打卡详情
 */
export function shanghuDayTasks(params) {
  return request({
    url: url + '/shanghu-task/shanghuDayTasks',
    method: 'get',
    params
  })
}

// 垃圾分类
export function subDayTasks(params) {
  return request({
    url: url + '/shanghu-task/subDayTasks',
    method: 'get',
    params
  })
}

/**
 * 批量审批商户数据
 */
export function auditBatch(params) {
  return request({
    url: url + '/shanghu-task/auditBatch',
    method: 'post',
    data:params
  })
}

/**
 * 查询商户提交情况（后台列表统计）
 */
export function shanghuSubmitCount(params) {
  return request({
    url: url + '/shanghu-task/shanghuSubmitCount',
    method: 'get',
    params
  })
}

/**
 * 查询商户提交情况（后台列表统计）
 */
export function subSubmitCount(params) {
  return request({
    url: url + '/shanghu-task/subSubmitCount',
    method: 'get',
    params
  })
}

// 堆物堆料列表统计
export function reportInfoCount(params) {
  return request({
    url: url + '/stackingMaterials/reportInfoCount',
    method: 'post',
    data: params
  })
}

/**
 * 任务列表
 * start
 */
// 任务分页列表
export function taskPage(params) {
  return request({
    url: url + '/gh-task/taskPage',
    method: 'post',
    data: params
  })
}
export function ksSubmitListExp(params) {
  return request({
    url: url + `/extend-infinite-task-index-batch/ksSubmitListExp?dayStr=${params.timeStr}`,
    method: 'get',
    responseType: 'blob',
  })
}
// 创建临时任务2(自定义事项类)
export function GhTaskTempTaskDiyParam(params) {
  return request({
    url: url + '/gh-task/GhTaskTempTaskDiyParam',
    method: 'post',
    data: params
  })
}
// 创建临时任务(已有事项类)
export function createTempTask(params) {
  return request({
    url: url + '/gh-task/createTempTask',
    method: 'post',
    data: params
  })
}
// 删除单条数据
export function delTask(params) {
  return request({
    url: url + '/gh-task/del',
    method: 'get',
    params
  })
}

//删除弹窗里的一条数据
export function delOneBatch(params) {
  return request({
    url: url + '/extend-infinite-task-index-batch/delOneBatchById',
    method: 'get',
    params
  })
}
// 查询单条数据
export function detailTask(params) {
  return request({
    url: url + '/gh-task/detail',
    method: 'get',
    params
  })
}
//消息列表分页查询
export function sysNoticePage(params) { //
  return request({
    url: url + '/ghSysNotice/sysNoticePage',
    method: 'post',
    data: params
  })
}
// 删除一条公告通知
export function delNotice(params) { //
  return request({
    url: url + '/ghSysNotice/delNotice',
    method: 'get',
    params
  })
}
// 撤回发布
export function backNotice(params) { //
  return request({
    url: url + '/ghSysNotice/backNotice',
    method: 'get',
    params
  })
}
// 发布一条公告通知
export function publicNotice(params) { //
  return request({
    url: url + '/ghSysNotice/publicNotice',
    method: 'get',
    params
  })
}
// 添加一条公告通知

export function addNotice(params) { //
  return request({
    url: url + '/ghSysNotice/addNotice',
    method: 'post',
    data: params
  })
}
// 更新一条公告通知
export function updateNotice(params) { //
  return request({
    url: url + '/ghSysNotice/updateNotice',
    method: 'post',
    data: params
  })
}
//查看一条详情
export function ghSysNoticDetail(params) { //
  return request({
    url: url + '/ghSysNotice/detail',
    method: 'get',
    params
  })
}
/**
 * 任务列表
 * end
 */
/**
 * 任务计划地图
 * start
 */
// 任务计划地图
export function pointPlanPic(params) { //
  return request({
    url: url + '/gh-task/pointPlanPic',
    method: 'post',
    data: params
  })
}
/**
 * 任务计划地图
 * end
 */
/**
 * 巡逻日历管理
 * start
 */
// 查询列表
export function holidayslist(params) { //
  return request({
    url: url + '/gh-working-and-holidays/list',
    method: 'get',
    params
  })
}
// 批量导入修改
export function importModify(params) { //
  return request({
    url: url + '/gh-working-and-holidays/importModify',
    method: 'post',
    data: params
  })
}
// 批量修改
export function batchEdit(params) { //
  return request({
    url: url + '/gh-working-and-holidays/batchEdit',
    method: 'post',
    data: params
  })
}
/**
 * 巡逻日历管理
 * end
 */

export function indexBatchbatchPage(params) { //
  return request({
    url: url + '/extend-infinite-task-index-batch/batchPage',
    method: 'post',
    data: params
  })
}

// 根据任务id导入各用户执行批次详细记录
export function indexBatchExp(params) { //
  return request({
    url: url + '/extend-infinite-task-index-batch/indexBatchExp',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

export function reportTaskAssignPage(params) { //
  return request({
    url: url + '/extend-report-task-handle/handlePage202411v',
    // url: 'http://192.168.1.102:8077' + '/extend-report-task-handle/handlePage202411v',
    method: 'post',
    data: params
  })
}

// 退回
export function reportTaskback(params) {
  return request({
    url: url + '/extend-report-task-handle/handleBack',
    method: 'post',
    data: params
  })
}
// 更换网格
export function modifyTaskPoint(params) {
  return request({
    url: url + '/extend-report-task/modifyTaskPoint',
    method: 'post',
    data: params
  })
}
// 更换网格
export function changeR4Dept(params) {
  return request({
    url: url + '/extend-report-task-handle/changeR4Dept',
    method: 'get',
    params
  })
}
export function reportfullDetail(params) {
  return request({
    url: url + `/extend-report-task/fullDetail?id=${params.id}`,
    method: 'get',
  })
}
export function reportTaskHandleExp(params) {
  return request({
    url: url + '/extend-report-task-handle/handleExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
export function handlePage202411vExp(params) {
  return request({
    url: url + '/extend-report-task-handle/handlePage202411vExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 上报问题统计分析
// 查询列表
export function reportTaskLeftHandlePage(params) { //
  return request({
    url: url + '/extend-report-task-handle/taskLeftHandlePage',
    // url: 'http://192.168.1.102:8077' + '/extend-report-task-handle/taskLeftHandlePage',
    method: 'post',
    data: params
  })
}
export function myReportPage(params) { //
  return request({
    url: url + '/extend-report-task/myReportPage',
    method: 'post',
    data: params
  })
}
// 居民留言导出
export function myReportPageExp(params) { //
  return request({
    url: url + '/extend-report-task/myReportPageExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 导出
export function reportTaskLeftHandleExp(params) {
  return request({
    url: url + '/extend-report-task-handle/taskLeftHandleExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 任务处置分页导出加图片展示-任务主表
export function taskLeftHandleImgExp(params) {
  return request({
    url: url + '/extend-report-task-handle/taskLeftHandleImgExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 导出统计
export function reportTaskLeftHandleTotalExp(params) {
  return request({
    url: url + `/extend-report-task-handle/taskLeftHandleTotalExp?timeStr=${params.timeStr}&timeEndStr=${params.timeEndStr}&reportSourceList=${params.reportSourceList}`,
    method: 'post',
    responseType: 'blob',
  })
}
// 上报问题统计分析导出
export function roleCompExp(params) {
  return request({
    url: url + `/extend-infinite-task-index-flow/roleCompExp`,
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 上报问题统计分析导出
export function sqCompExp(params) {
  return request({
    url: url + `/extend-infinite-task-index-flow/sqCompExp`,
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
export function infiniteTotalExp(params) {
  return request({
    url: url + `/extend-report-task-handle/infiniteTotalExp?timeStartStr=${params.timeStr}&timeEndStr=${params.timeEndStr}`,
    method: 'get',
    responseType: 'blob',
  })
}

// 孤寡老人-列表查询
export function extendGglrRkPage(params) {
  return request({
    url: url + '/extend-gglr-rk/page',
    method: 'post',
    data: params
  })
}
// 非日常巡查自定义管理-列表查询
export function extendclrRkPage(params) {
  return request({
    url: url + '/extend-cl-rk/page',
    method: 'post',
    data: params
  })
}
// 新增修改单条数据
export function extendGglrRkEdit(params) {
  return request({
    url: url + '/extend-gglr-rk/edit',
    method: 'post',
    data: params
  })
}
// 删除
export function delmanger(params) {
  return request({
    url: url + '/extend-cl-rk-manger/del',
    method: 'get',
    params
  })
}
// 删除
export function delclrk(params) {
  return request({
    url: url + '/extend-cl-rk/del',
    method: 'get',
    params
  })
}
// 新增修改单条数据
export function extendclRkEdit(params) {
  return request({
    url: url + '/extend-cl-rk/edit',
    method: 'post',
    data: params
  })
}
// 202411v社区书记认领任务或提级到包片领导
export function sqClaimOrLevelUp202411v(params) {
  return request({
    url: `${url}/extend-report-task-handle/sqClaimOrLevelUp202411v`,
    method: "post",
    data: params,
  });
}

// 202411v包片领导认领或提级到职能部门
export function bpClaimOrLevelUp202411v(params) {
  return request({
    url: `${url}/extend-report-task-handle/bpClaimOrLevelUp202411v`,
    method: "post",
    data: params,
  });
}

// 任务认领
export function claimTask(params) {
  return request({
    url: `${url}/extend-report-task-handle/claim?taskHandleId=${params.taskHandleId}`,
    method: "get",
  });
}

// 任务处置
export function handleTask(params) {
  return request({
    url: `${url}/extend-report-task-handle/handle`,
    method: "post",
    data: params,
  });
}

// 不同角色任务清单填报比对
export function taskIndexFlowRoleComp(params) {
  return request({
    url: `${url}/extend-infinite-task-index-flow/roleComp`,
    method: "post",
    data: params,
  });
}
// 不同角色任务清单填报比对 ---新新
export function taskIndexFlowSqComp(params) {
  return request({
    url: `${url}/extend-infinite-task-index-flow/sqComp`,
    method: "post",
    data: params,
  });
}

export function taskIndexFullDel(params) {
  return request({
    url: `${url}/extend-report-task/fullDel`,
    method: "GET",
    params,
  });
}

export function taskChooseExportFeildList(params) {
  return request({
    url: `${url}/extend-report-task-handle/taskChooseExportFeildList`,
    method: "GET",
    params,
  });
}

//最近10分钟上报问题详情，网格点位分布-中心地图使用
export function pastTenMinReportDistribution(params) {
  return request({
    url: `${url}/gh-managementCockpit/pastTenMinReportDistribution`,
    method: "GET",
    params,
  });
}


// 自主创建长期任务
export function createInfiniteTask(params) {
  return request({
    // url: `http://192.168.1.122:8077/extend-infinite-task-index-flow/createInfiniteTask`,
    url: `${url}/extend-infinite-task-index-flow/createInfiniteTask`,
    method: "post",
    data: params,
  });
}

export function infiniteEventFullDetail(params) {
  return request({
    // url: `http://192.168.1.122:8077/extend-infinite-task-index-flow/infiniteEventFullDetail`,
    url: `${url}/extend-infinite-task-index-flow/infiniteEventFullDetail`,
    method: "GET",
    params,
  });
}
// 打卡轨迹
export function userLocationLine(params) { //
  return request({
    url: url + '/extendHome/userLocationLine',
    method: 'post',
    data: params
  })
}
// 打卡轨迹
export function userLocationLineExp(params) { //
  return request({
    url: url + '/extendHome/userLocationLineExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 打卡轨迹
export function authUserDeptList(params) { //
  return request({
    url: url + '/extendHome/authUserDeptList',
    method: 'post',
    params
  })
}

// 工作日记日历
export function dayDutyList(params) {
  return request({
    url: url + '/event-duty-work/dayDutyList',
    method: 'post',
    data: params
  })
}

// 堆物堆料导出数据
export function exportReportInfo(params) {
  return request({
    url: url + '/stackingMaterials/exportReportInfo',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}


// 导出工作数据
export function dutyWordExp(params) {
  return request({
    url: url + '/event-duty-work/dutyWordExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 商户打卡列表
export function exportTaskInfo(params) {
  return request({
    url: url + '/shanghu-task/exportTaskInfo',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 用户数据
export function authUserlist(params) {
  return request({
    url: url + '/extendHome/authUserlist?noAuthFlag=false',
    method: 'post',
    data: params
  })
}

/**
 * 
 * @param {*} params 
 * @returns 非日常巡查
 */

// 获取所有的社区列表
export function getCommcommunityAll(params) {
  return request({
    url: url + '/gh-point-level/getCommcommunityAll',
    method: 'get',
    params
  })
}

// 巡查类型列表
export function selMyDoList(params) {
  return request({
    url: url + '/gh-event-type/selMyDoList',
    method: 'post',
    data: params
  })
}

// 巡查该类型列表
export function batchGroupSomeList(params) {
  return request({
    url: url + '/extendTaskmore/batchGroupSomeList',
    method: 'post',
    data: params
  })
}

// 任务列表
export function extendTaskPage(params) {
  return request({
    url: url + '/extendTaskmore/extendTaskPage',
    method: 'post',
    data: params
  })
}

// 任务列表 详情
export function extendTaskDetail(params) {
  return request({
    url: url + '/extendTaskmore/extendTaskDetail',
    method: 'get',
    params
  })
}

export function extendTaskPageExp(params) {
  return request({
    url: url + '/extendTaskmore/extendTaskPageExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 后台错题本分页
export function extendErrPage(params) {
  return request({
    url: url + '/extend-report-task/errPage',
    method: 'post',
    data: params
  })
}

// 错题本审批
export function extendErrAudit(params) {
  return request({
    url: url + '/extend-report-task/errAudit',
    method: 'post',
    data: params
  })
}


// ---- 文化积淀 ----

// 删除评论
export function commentDel(params) {
  return request({
    url: url + '/whjd-story-comment/del',
    method: 'get',
    params
  })
}

// 更新全部文章
export function updateAllStory(params) {
  return request({
    url: url + '/whjd-story/updateAllStory',
    method: 'get',
    params
  })
}

// 文化积淀分页查询
export function storyPageHt(params) {
  return request({
    url: url + '/whjd-story/storyPageHt',
    method: 'post',
    data: params
  })
}

// 查询单条数据
export function storyDetail(params) {
  return request({
    url: url + '/whjd-story/detail',
    method: 'get',
    params
  })
}

// 评论
export function commentStoryPageQt(params) {
  return request({
    url: url + '/whjd-story-comment/storyPageQt',
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/task.js